import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductName = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productName =
    product[`name_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productName) {
    apmCaptureError(
      new Error(
        `GK_AIR: product name not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productName
}
